import { gql } from "@apollo/client";

const GET_DATABUNDLES = gql`
    query GetDataBundles($network: String!) {
        getDataBundles(network: $network) {
            allowance
            datacode
            id
            name
            price
            validity
        }
    }
`;

export {
    GET_DATABUNDLES
}